import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DynamicPagePresetMutationKeys } from '../../../keys'
import type { DuplicateDynamicPagePresetResponse } from '../../../type'
import { duplicateDynamicPagePreset } from '../../services'

interface UseMutationDuplicatePresetProps {
	presetId: string
}

export default function useMutationDuplicateDynamicPagePreset(
	props?: UseBaseMutationOptions<
		DuplicateDynamicPagePresetResponse,
		UseMutationDuplicatePresetProps
	>,
) {
	return useMutation({
		mutationKey: [DynamicPagePresetMutationKeys.DuplicateDynamicPagePreset],
		mutationFn: (params) => duplicateDynamicPagePreset(params.presetId),
		...props,
	})
}
